import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function DataPagination({ page, pageCount, total, onPage }) {
  if (pageCount <= 1) return null;
  const pages = [];
  const start = Math.max(1, Math.min(page - 2, pageCount - 4));
  const end = Math.min(pageCount, start + 4);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-slate-200 bg-white">
      <span className="text-xs text-slate-400">{total} elementi · pagina {page}/{pageCount}</span>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="icon" data-testid="page-prev" disabled={page === 1}
          onClick={() => onPage(page - 1)} className="h-8 w-8">
          <ChevronLeft className="h-4 w-4" />
        </Button>
        {pages.map((p) => (
          <Button key={p} variant={p === page ? "default" : "outline"} size="icon"
            data-testid={`page-${p}`} onClick={() => onPage(p)}
            className={`h-8 w-8 text-xs ${p === page ? "bg-blue-700 hover:bg-blue-800" : ""}`}>
            {p}
          </Button>
        ))}
        <Button variant="outline" size="icon" data-testid="page-next" disabled={page === pageCount}
          onClick={() => onPage(page + 1)} className="h-8 w-8">
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
